import { IServices } from "@netent/origin";
import { PlayUIListenerCreator } from "../../types";

export const onSpinRequest: PlayUIListenerCreator = (
  services: IServices
) => () => {
  if (services.autoplay.isActive()) {
    services.autoplay.stop();
  } else if (services.win.isPresentationActive()) {
    services.win.abortPresentation();
  } else if (services.gameRound.isRoundActive()) {
    services.spin.quickStop();
  } else if (services.autoplay.getRemaining() > 0) {
    services.autoplay.start();
  } else if (services.paytable.isOpen()) {
    services.paytable.close();
  } else if (services.gameSettings.isOpen()) {
    services.gameSettings.close();
  } else if (services.gameRules.isOpen()) {
    // TODO: Update Origin index.d.ts to include closePopup, openPopup methods
    // services.gameRules.closePopup();
    services.gameSettings.open();
    services.gameSettings.close();
    // This is case for BET_SETTINGS open state
  } else if (
    services.gameSettings.isAnySettingsOpen() &&
    !services.gameSettings.isOpen()
  ) {
    // TODO: Add some API methods to check, open and close BET_SETTINGS
    services.gameSettings.open();
    services.gameSettings.close();
  } else {
    services.gameRound.start();
  }
};
